/* eslint-disable camelcase */

import { getCookieValue } from 'Utilities';
import { GuideData } from 'Utilities/guides/@types/guide';
import { User } from 'Utilities/user/@types';
import { WordpressGuideSummaryData } from 'Utilities/wordpress/@types';

import { LogoMakeType } from 'Storybook/components/local/LogoMake/LogoMake.helpers';

import { WordpressData } from '../shared/containers/app/contentPages/wordPressPages/@types/Wordpress';

// Note: Types should be moved to appropriate Utilities section when they are
// used by components.

type Affiliate = {
  createdAt: string;
  id: number;
  name: string;
  showBranding: boolean;
  slug: string;
  updatedAt: string;
}

type LandingPageData = {
  archive: null;
  content: any; // TODO: PIR-624 to create type
  meta: {
    desc: string;
    description: string;
    title: string;
  };
  posts: [];
  title: string;
}

export type Brand = {
  createdAt: string;
  display_name: string;
  id: number;
  major: number;
  map_id: string;
  slug: LogoMakeType;
  updatedAt: string;
}

export type BrandData = {
  brand?: Brand;
  brandContent?: {
    main: string;
  };
  brands?: Brand[];
}

export type RecentSale = {
  sale: {
    soldDate: string;
    soldPrice: number;
  };
  seller: {
    firstName: string;
  };
  vehicle: {
    leadPhoto: {
      url: string;
    };
    make: string;
    model: string;
  };
}

export type FeatureFlagsType = { [key: string]: boolean };

export type InitialState = {
  affiliate?: Affiliate;
  appClipUrl: string;
  appName: string;
  appVersion: string;
  authn: string;
  brandData: BrandData | null;
  customerVehicleLimit: {
    retail?: string;
  };
  experimentDecisions: Record<string, string>;
  featureFlags: FeatureFlagsType;
  gateway: string;
  gmapsKey: string;
  guideData: GuideData | null;
  guidesPreviewData: WordpressGuideSummaryData[] | null;
  hideAnnouncement: boolean;
  hideDealerDetails?: number[] | null;
  isNewDesign: boolean | undefined;
  landingPageData?: LandingPageData;
  optimizelySdk: string;
  photoUploader: string;
  photosAppUrl: string;
  providersVersions?: string;
  recentSales: RecentSale[] | null;
  reviewsApi: string;
  reviewsData: {
    rating: string;
    totalReviews: string;
  };
  sitemapData?: {
    blog: [];
    guides: [];
    makes: [];
    misc: [];
    sell: [];
  };
  statSigKey: string;
  user: User | null;
  wordpressApi: string;
  wordpressData: WordpressData | null;
  youtubeEmbedURL: string;
};

export type InitialContext = {
  buyer: {
    name: string;
    slug: string;
  };
  failed: boolean;
}

export const getOptimizelyUserId = () => process.env.OPTIMIZELY_TEST_USER_ID || getCookieValue('Optimizely-User-Id') || crypto.randomUUID();
